var _defs, _path, _polygon, _polyline, _path2, _polyline2, _path3, _polyline3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProhibition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.73,238A15.27,15.27,0,0,1,45.5,222.77V67.9L102,18h93.26A15.27,15.27,0,0,1,210.5,33.23V222.77A15.23,15.23,0,0,1,195.27,238Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "102.01 18 101.77 67.82 45.5 67.9 102.01 18"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "170.5 132.96 187.98 127.26 187.98 119.14 127.98 102.01 67.99 119.14 67.99 127.26 127.98 146.82 170.5 132.96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M94.73,136.84v22.89c7.53,7.16,19.43,11.74,32.5,11.74s25-4.58,32.49-11.74V137.29"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "171.04 162.54 171.04 126.97 130.89 116.14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.54,169.36a6.49,6.49,0,1,1-6.49-6.49A6.48,6.48,0,0,1,177.54,169.36Z"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "168.12 175.38 164.54 189.99 177.57 189.99 173.98 175.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProhibition);
export default __webpack_public_path__ + "static/media/prohibition.92711a266ac750898eb046ae23942ded.svg";
export { ForwardRef as ReactComponent };